export default [
    {
        name: 'CopyRightDetails',
        path: 'CopyRightDetails',
        redirect: { name: 'RawMaterials' },
        component: () => import('@/pages/BigData/PatentModule/CopyRightDetails'),
        meta: { title: '详情' },
        props(route) {
            return { id: route.query.id }
        },
        children: [
            {
                name: 'RawMaterials',
                path: 'RawMaterials',
                component: () => import('@/pages/BigData/PatentModule/CopyRightDetails/RawMaterials'),
                meta: { title: '原始材料' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            },
            {
                name: 'ConfirmMaterial',
                path: 'ConfirmMaterial',
                component: () => import('@/pages/BigData/PatentModule/CopyRightDetails/ConfirmMaterial'),
                meta: { title: '需确认材料' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            }

        ]
    },
    {
        name: 'waAll',
        path: 'waAll',
        component: () => import('@/pages/BigData/PatentModule/Copywriting/waAll'),
        meta: { title: '全部' },
        props(route) {
            return { id: route.query.id }
        }
    },
    {
        name: 'ToBeWritten',
        path: 'ToBeWritten',
        component: () => import('@/pages/BigData/PatentModule/Copywriting/ToBeWritten'),
        meta: { title: '待撰写' },
        props(route) {
            return { id: route.query.id }
        }
    },
    {
        name: 'waWriting',
        path: 'waWriting',
        component: () => import('@/pages/BigData/PatentModule/Copywriting/waWriting'),
        meta: { title: '撰写中' },
        props(route) {
            return { id: route.query.id }
        }
    },
    {
        name: 'waConfirming',
        path: 'waConfirming',
        component: () => import('@/pages/BigData/PatentModule/Copywriting/waConfirming'),
        meta: { title: '确认中' },
        props(route) {
            return { id: route.query.id }
        }
    },
    {
        name: 'waConfirmed',
        path: 'waConfirmed',
        component: () => import('@/pages/BigData/PatentModule/Copywriting/waConfirmed'),
        meta: { title: '已确认' },
        props(route) {
            return { id: route.query.id }
        }
    },

]